import React, { createContext, useContext, useState, ReactNode } from 'react';

interface RolePermissionContextType {
  role: string;
  permissions: string[];
  setRole: (role: string) => void;
  setPermissions: (permissions: string[]) => void;
}

const RolePermissionContext = createContext<RolePermissionContextType | undefined>(undefined);

export const useRolePermission = () => {
  const context = useContext(RolePermissionContext);
  if (!context) {
    throw new Error('useRolePermission must be used within a RolePermissionProvider');
  }
  return context;
};

export const RolePermissionProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [role, setRole] = useState<string>('');
  const [permissions, setPermissions] = useState<string[]>([]);

  return (
    <RolePermissionContext.Provider value={{ role, permissions, setRole, setPermissions }}>
      {children}
    </RolePermissionContext.Provider>
  );
};
